export const popupKeyData = {
    SOFTWARE:'software',//软件中心
    CONVERSION:'conversion',//经纬度转换
    TERRAIN:'terrain',//地形处理
    TERRAIN_IMAGE: 'terrainImage',//地形处理-图片
    MAP:'map',//地图处理
    FEEDBACK:'feedback',//问题反馈,
    MESSAGE: 'message',//消息管理
    DOWNLOAD: 'download'//下载管理
}

export const maxName = (key) => {
    return popupKeyData[key]+'Visible';
}

export const minName = (key) => {
    return popupKeyData[key]+'MinVisible';
}